let CreditsText = "积分12";
// if (window.sessionStorage.getItem("MODULEDATA")) {
//     CreditsText = JSON.parse(window.sessionStorage.getItem("MODULEDATA")).creditName || "积分";
// }
// console.log(CreditsText);
/***
 * 星展银行特殊处理
 * aon积分名称修改“iFlex积分” 英文“iFlex points”
   节日积分名称修改为员工俱乐部积分，英文“Club points”
 * ***/
let aon = 'Aon '
let festival = '节日'
let ordinary = '普通'

let iFlex =JSON.parse(sessionStorage.getItem('MODULEDATA'))? JSON.parse(sessionStorage.getItem('MODULEDATA')).iFlex : ''
if(iFlex){
  aon = 'iFlex'
  festival = '员工俱乐部'
  ordinary = '其他'

}
export const message = {
  ordinary:ordinary,
  festival:festival,

    confirm_order_tip1: '由于地址信息调整的，请重新编辑当前收货地址中“所在区域”选项，即可顺利下单！',
    confirm_order_btn1: '去完善',
    FrequentlyAskedQuestions: '常见问题',
    FrequentlyAskedQuestions_weini: '跨境商品常见问题',
    weiNiInternational: '跨境海淘',
    integralBuckle: CreditsText + '可抵',
    paymentQuestion: '支付疑问',
    shipAddress: '发货地',
    paymentQuestionTitle1: '发货方式',
    paymentQuestionTitle2: '税费',
    containsFees: '包含税费',
    troubleShooting: '问题解答',
    paymentQuestionTitle3: '福粒抵扣',
    paymentQuestionCon1: '跨境商品经由海外或保税仓发货，根据商品不同的情况，会分为不同关口保税仓发货。收货时效性也会不相同',
    paymentQuestionCon2: '购买海外商品需依法向中国海关申报及纳税',
    paymentQuestionCon3: '福粒商品由多种类供应商提供货物，其中货物部分由海外仓直接发货，根据中国海关申报条件。需要用户支付单、物流单、订单号信息（商品、支付金额等信息）必须通过海关申报。',
    paymentQuestionCon4: '如您遇到部分商品只能抵扣部分金额，给您带来不便请谅解！',
    pay_attention_to: '去关注',
    money_z: '元',
    attention_tip1: '关注公众号购买商品再省',
    attention_tip2: '关注公众号',
    attention_tip3: '您已关注公众号',
    attention_tip4: '本商品可减免',
    attention_tip5: '取消关注将不再享受此优惠哦！',
    focus_on_relief: '关注减免',
    has_been_cut: '已减免',
    attention_tip6: '购买商品省',
    attention_tip7: '购买商品预计省',
    attention_tip8: '微信扫描二维码关注公众号，本商品可立减',
    info_tip3: '·不支持7天无理由退换货 · 身份证核验 · 现金支付',
    shopCart01: '您选中的商品包含国际商品',
    shopCart02: '需要和其他商品分开结算',
    shopCart03: '跨境海淘',
    yourCart: '我的购物车',
    checkTheCart: '查看购物车',
    checkOrderInfo: '填写核对订单信息',
    placeTheOrder: '购买成功',
    selectAll: '全选',
    departemployeeText:'已离职，请先移除！',
    departemployeeTip:'该员工已离职，不可选择哦！',
    product: '商品信息',
    specification: '规格',
    price: '单价',
    quantity: '数量',
    ExtPrice: '总价',
    ExtPrice2: '小计',
    noGoods: '此地区无货',
    pleaseChoose: '请选择',
    state: '状态',
    stock: '库存',
    operation: '操作',
    delete: '删除',
    total: '总计',
    proceedToOrder: '结算',
    contactInfo: '联系人信息',
    addYourAddressFirst: '您还没有收货地址，请先添加',
    addAnAddress: '添加收货地址',
    checkTheOrder: '确认订单信息',
    discounts: '优惠',
    points: CreditsText,
    YourCurrentPoint: '共',
    YourCurrentPoint2: '福粒币',
    youCouldUse: '可抵扣',
    thisTime: '元',
    coupons: '优惠券',
    available: '张可用',
    noUsingOfCoupons: '不使用优惠券',
    delivery: '配送方式',
    freight: '运费',
    support: '支持',
    paymentMethod: '支付方式',
    youHaveToPay: '需要支付金额',
    orderInfo: '订单结算',
    productsPrice: '商品总价',
    freightPrice: '物流费用',
    discountsPrice: '促销优惠',
    proceedToOrder2: '提交订单',
    price2: CreditsText + '价',
    fuli: '福粒',
    distributionTo: '配送至',
    inStock: '有货',
    outStock: '无货',
    pts: CreditsText,
    quantity2: '购买数量',
    addToCart: '加入购物车',
    productIsSoldOut: '商品缺货',
    productInfo: '商品详情',
    afterSalesService: '售后保障',
    hello: '您好',
    yourCurrentPo: '您现在的' + CreditsText + '为：',
    hdPoint: '点',
    yourOrders: '我的订单',

    yourAccount: '我的账户',
    welcome: '欢迎',
    benefitModules: '福利模块',
    accountManagement: '账号管理',
    changePassword: '修改密码',
    close:'关闭',
    Ques: {
        OrderingGuide: '订购指南',
        MemberAccount: '会员账户',
        OrderMethods: '订购方式',
        PaymentTerms: '交易条款',
        ReturnsReplacements: '退/换货政策',
        CarrierInformation: '运费标准',
        PaymentDelivery: '支付配送',
        PaymentMethods: '支付方式',
        DeliveryTimes: '配送时间',
        DeliveryAreas: '配送范围',
        CheckSign: '签收验货',
        CustomerCenter: '顾客中心',
        TermsofUse: '使用条款',
        RulesofPoints: CreditsText + '规则',
        GuaranteePolicy: '三包政策',
        InformationProtection: '信息保护',
        AboutUs: '关于我们',
        Clients: '合作伙伴',
        LegalNotice: '法律公告',
        ContactUs: '联系我们'
    },
    fuliCo: '福粒公司版权所有2013-2019',
    Screening: '筛选',
    PriceLow: '价格从低到高',
    PriceHigh: '价格从高到低',
    SaleLow: '销量从低到高',
    SaleHigh: '销量从高到低',
    NewArrival: '新品',
    Category: '商品目录',
    Help: '帮助中心',
    CompanyIntro: '公司介绍',
    specialRecommend: '特别推荐',
    PricesForCustom: '价格定制',
    Discounts: '精选特惠',
    Search: '搜索',
    LowPrice: '正品低价',
    WorryfreeAftersalesService: '无忧售后',
    QualityGuarantee: '品质保障',
    StandardCredits: ordinary + CreditsText,
    FestivalCredits: festival + CreditsText,
    aonCredits: ''+ aon +'积分',
    aonCreditsNo: ''+ aon +'积分无明细',
    aonCreditsText: ''+aon+'积分为对接怡安平台积分数据，实时消耗数据请登录怡安平台进行查看！',
    creditsChane:'可选择'+ CreditsText+'进行抵扣',
    fixNav: {
        Coupon: '优惠券',
        Cart: '购物车',
        Credits: CreditsText,
        Orders: '订单',
        QRCode: '二维码',
        applet: '小程序',
        Tencent: '公众号',
        scanQRCode: '扫描二维码',
        followthewechatofficialaccount: '关注公众号',
        onlinecustomerservice: '在线客服',
        onlinetime: '在线时间',
        customerservice: '客服',
        contactcustomerservice: '联系客服',
        callcenter: '客服电话',
        workingday: '工作日',
        yourID: '您的用户名/企业名',
        pleasefeedbacktothecustomerservicepeople: '反馈时告知客服哦',
        top: '顶部'
    },
    newaddress: '新增收货地址',
    editAddress: '编辑收货地址',
    addressinformation: '地址信息',
    Townshipstreet: '乡镇街道',
    addressdetail: '详细地址',
    consigneename: '收货人姓名',
    phoneNo: '手机号码',
    identitycard: '身份证号码',
    defaultaddress: '设置为默认收货地址',
    save: '保存',
    cancel: '取消',
    suggest: {
        construction_content: '建议内容',
        suggested_type: '建议类型',
        status: '状态',
        see_feedback: '查看反馈',
        have_acccepted: '已受理',
        being_processed: '处理中',
        complaints_immediately: '立即投诉建议',
        reply_content: '回复内容',
        upload_pictures: '上传图片',
        suggest_tip1: '建议尺寸 350*120 只能上传jpg/png/bmp文件，且单个文件不超过3M',
        suggest_tip2: '您的每一个反馈，都是对我们的有力支持！感谢您的参与！',
        submissions: '提交内容',
        complaints_time: '投诉时间',
        complaint_category: '投诉类别',
        complaint_content: '投诉内容',
        documentary_evidence: '证明文件',
        advice_feedback: '建议反馈',
        suggest_tip3: '您的建议内容我们已经收到，相关问题和内容会在第一时间给你反映。感谢您的支持！',
        goBack: '返回',

    },
    MY: {
        myaccount: '我的主页',
        ordercenter: '订单中心',
        myorders: '我的订单',
        customercenter: '客户中心',
        complaint_advice: '投诉建议',
        mydiscountcoupon: '我的优惠券',
        myaftersalesservice: '我的售后',
        myElectronicCard: '我的卡密',
        accountcenter: '账户中心',
        mycredits: '我的' + CreditsText,
        deliveryaddress: '收货地址'
    },
    Profile: {
        accountinformation: '账户信息',
        basicinformation: '基本信息',
        realname: '真实姓名',
        userID: '用户名',
        company: '公司',
        phoneno: '手机号码',
        changePasswordNow: '立即修改'
    },
    startorder: '立即购买',
    Order: {
        orderNo: '订单号',
        picture: '商品图',
        productname: '商品名称',
        specifications: '规格',
        totalprice: '商品总价',
        status: '状态',
        operation: '操作',
        details: '查看详情',
        orderinformation: '订单信息',
        details2: '详细信息',
        shippingfee: '物流费用',
        tax: '税费',
        coupon: '优惠金额',
        creditpoint: '福粒' + CreditsText + '抵扣',
        actualpayment: '实付款',
        paymenttime: '付款时间',
        ordertime: '下单时间',
        productlist: '商品清单',
        productpicture: '商品图',
        price: '价格',
        quantity: '商品数量',
        shippinginformatio: '物流信息',
        checkshippinginformation: '查看物流详情',
        address: '配货地址',
        consignee: '收货人',
        address2: '送货地址',
        contact: '联系电话',
        remarks: '留言备注',
        Pleasefillintheordernotes: '请您填写留言备注',
        shipCompany: '物流公司',
        shipOrderNo: '物流单号',
        noLogisticsInfo: '暂无物流信息',
        deliveryNote: '发货备注',
        previousOrderQueryBtn: '历史订单信息查询 请点击',
        previousOrderQuery: '历史订单信息',
        checkCardPwd: '查看卡密',
        couponDeduction: '优惠券抵扣',
        orderPrice: '订单总价',
    },
    confirm_03_0: '您的订单存在未支付订单，当未支付订单完成结算后即可享受减免您未关注公众号不享受减免！',
    succeed: '恭喜您购买成功',
    orderNo: '订单编号',
    amount: '应付金额',
    payment: '支付方式',
    paybycredits: '福粒支付',
    alipay: '支付宝支付',
    Alipay: '支付宝',
    WeChat: '微信',
    WeChatPayment: '微信支付',
    topay: '去支付',
    check: '查看',
    availablePoint: '我的可用' + CreditsText,
    none: '无',
    payNow: '立即支付',
    cancelOrder: '取消订单',
    applyReturn: '申请售后',
    ConfirmReceipt: '确认收货',
    confirmPay: '确定支付',
    afterSale: '售后',
    loginOut: '退出',
    index: '返回首页',
    integral: CreditsText, // 商品列表 积分
    outStockProdTip: '该商品已下架，欢迎挑选其他商品！',
    seckillPrice: '秒杀价',
    originalPrice: '原价',
    creditsDeduction: CreditsText+'抵扣',
    receiveImmediately: '立即领取',
    toUse: '去使用',
    received: '可使用{0}张',
    receivedAgain: '再次领取',
    noCouponTip: '优惠券活动暂未开启!',
    placeWait: '请您耐心等待！',
    noCouponProdTip: '您的公司已经对此类商品进行限制!',
    noCouponProdTip2: '请您查看其他优惠券活动!',
    virtualGoodsTip: '此商品为虚拟物品，下单无法进行退货请提前查看商品详情!',
    buyNow: '立即抢购',
    timeRemaining: '距离结束',
    seckillEnd: '该秒杀已结束',
    noSeckillTip: '秒杀活动暂未开启！',
}



// WEBPACK FOOTER //
// ./src/config/zh-CN.js